import { all, put, select } from 'redux-saga/effects';
import groupBy from 'lodash/groupBy';
import { selectors, withOffset } from '../../Stream';
import { GALLECTIONS_PER_FETCH, MEDIA_POPUP_GALLECTION_STREAM_GROUP } from '../constants';
import { getGallectionStreamId } from '../helpers';
import { getMode, getCurrentMediaSource } from '../selectors';
import { MediaPopupMode } from '../types';
import { normalizeGallections } from '../../redux/normalizr/helpers';
export function getStreamInitAction(mediaSource, folderId, gallectionFolders = []) {
    const streamId = getGallectionStreamId(mediaSource, folderId);
    const normalizedGallections = normalizeGallections(gallectionFolders);
    const streamParams = {
        mediaSource
    };
    return withOffset.actions.initialize({
        streamId,
        groupId: MEDIA_POPUP_GALLECTION_STREAM_GROUP,
        streamParams,
        itemsPerFetch: GALLECTIONS_PER_FETCH,
        hasMore: !gallectionFolders,
        items: normalizedGallections && normalizedGallections.result,
        entities: normalizedGallections && normalizedGallections.entities
    });
}
function* handleInitGallectionStream(action) {
    const mediaSource = yield select(getCurrentMediaSource);
    if (!mediaSource) {
        return;
    }
    const { gallectionFolders  } = action.payload || {};
    const streamId = getGallectionStreamId(mediaSource);
    const mode = yield select(getMode);
    const isStreamInitialized = yield select(selectors.isInitialized, streamId);
    let cacheStreams = true;
    if (mode === MediaPopupMode.MANAGER) {
        cacheStreams = false;
    }
    if (isStreamInitialized && cacheStreams) {
        return;
    }
    if (gallectionFolders && gallectionFolders.length) {
        const foldersByParentId = groupBy(gallectionFolders || [], 'parentId');
        yield all(Object.keys(foldersByParentId).filter((parentId)=>+parentId).map((parentId)=>{
            const folders = foldersByParentId[parentId];
            return put(getStreamInitAction(mediaSource, +parentId, folders));
        }));
    } else {
        yield put(getStreamInitAction(mediaSource, undefined, []));
    }
    if (!gallectionFolders) {
        yield put(withOffset.actions.fetch(streamId));
    }
}
export default handleInitGallectionStream;
